import React from 'react';
import { Button, Col, Row, FormGroup } from 'reactstrap';
import PropTypes from 'prop-types';
import { removeItemWithConfirm } from '../../common/classes/handleItemWithConfirm';
import FacilityGroup from './facilityGroup';
import SinglePicker from '../../common/controls/singlePicker';
import TextInput from '../../common/controls/textInput';
import Icon from '../../common/containers/icon';
const confirmOnRemoveFields = ['name', 'facilityEnvironmentID', 'facilityPrimaryConditionID', 'facilityGroups'];
const Facility = _ref => {
  let propsIndex = _ref.index,
    facility = _ref.facility,
    facilityEnvironments = _ref.facilityEnvironments,
    facilityPrimaryConditions = _ref.facilityPrimaryConditions,
    onAdd = _ref.onAdd,
    onChange = _ref.onChange,
    onRemove = _ref.onRemove;
  const facilityGroups = facility.facilityGroups || [];
  const handleAdd = (path, value) => onAdd("facilities[".concat(propsIndex, "]/").concat(path), value);
  const handleChange = (name, value) => onChange(propsIndex, name, value);
  const removeFacility = () => removeItemWithConfirm(facility, 'Facility', confirmOnRemoveFields, onRemove.bind(null, propsIndex));
  const changeFacilityPrimaryConditionID = value => handleChange('facilityPrimaryConditionID', value);
  const changeFacilityEnvironmentID = value => handleChange('facilityEnvironmentID', value);

  // methods for child facilityGroup
  const addFacilityGroup = () => {
    const newValue = {
      facilityID: facility.id,
      facilityGroupAreas: []
    };
    handleAdd('facilityGroups', newValue);
  };
  const changeFacilityGroup = (index, name, value) => handleChange("facilityGroups[".concat(index, "]/").concat(name), value);
  const removeFacilityGroup = index => {
    const newFacilityGroups = JSON.parse(JSON.stringify(facilityGroups));
    newFacilityGroups.splice(index, 1);
    handleChange('facilityGroups', newFacilityGroups);
  };
  const facilityGroupComponents = facilityGroups.map((nextFG, index) => /*#__PURE__*/React.createElement(FacilityGroup, {
    index: index,
    facilityGroup: nextFG,
    key: nextFG.id,
    onChange: changeFacilityGroup,
    onRemove: removeFacilityGroup,
    onAdd: handleAdd
  }));
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '1rem'
    }
  }, /*#__PURE__*/React.createElement(Row, {
    className: "bottom-align-row"
  }, /*#__PURE__*/React.createElement(Col, {
    xs: 9
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Facility Name",
    field: "name",
    data: facility,
    onChange: handleChange,
    entity: "Facility"
  })), /*#__PURE__*/React.createElement(Col, {
    xs: 3,
    style: {
      paddingTop: 23
    }
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Button, {
    block: true,
    className: "t-f-remove tqc-control",
    onClick: removeFacility
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "trash"
  }), " Remove Facility")))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 3
  }, /*#__PURE__*/React.createElement(SinglePicker, {
    label: "Environment",
    labelKey: "name",
    onChange: changeFacilityEnvironmentID,
    options: facilityEnvironments,
    placeholder: "Select...",
    value: facility.facilityEnvironmentID,
    returnValueKey: "id",
    searchable: false
  })), /*#__PURE__*/React.createElement(Col, {
    xs: 6
  }, /*#__PURE__*/React.createElement(SinglePicker, {
    label: "Primary Condition",
    labelKey: "name",
    onChange: changeFacilityPrimaryConditionID,
    options: facilityPrimaryConditions,
    placeholder: "Select...",
    value: facility.facilityPrimaryConditionID,
    returnValueKey: "id",
    searchable: false
  }))), facilityGroupComponents, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    style: {
      marginTop: 10
    },
    sm: {
      size: 3,
      offset: 9
    }
  }, /*#__PURE__*/React.createElement(Button, {
    block: true,
    className: "t-f-add-group tqc-control",
    onClick: addFacilityGroup
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "plus"
  }), " New Group"))));
};
Facility.propTypes = {
  index: PropTypes.number.isRequired,
  onAdd: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  facility: PropTypes.shape({
    facilityGroups: PropTypes.arrayOf(PropTypes.shape({})),
    id: PropTypes.string,
    facilityPrimaryConditionID: PropTypes.string,
    facilityEnvironmentID: PropTypes.string
  }).isRequired,
  facilityEnvironments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  facilityPrimaryConditions: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export default Facility;